
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mottagning",
      function () {
        return require("private-next-pages/mottagning/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mottagning"])
      });
    }
  